/** @jsx jsx */
import { jsx, Flex, Box } from "theme-ui"

const Item = ({ name, content }) => (
  <Flex
    sx={{
      flexDirection: `column`,
      "&:not(:last-of-type)": {
        mr: 5,
      },
      mb: 2,
    }}
  >
    <div
      sx={{
        textTransform: `uppercase`,
        color: `primary`,
        letterSpacing: `wider`,
        fontWeight: `semibold`,
      }}
    >
      {name}
    </div>
    <Box as="p" variant="styles.p">
      {content}
    </Box>
  </Flex>
)

const ProjectInfo = ({ project }) => (
  <Flex sx={{ mt: 4, mb: [2, 4], flexWrap: `wrap` }}>
    <Item name="Date" content={project.date} />
    <Item name="Tools" content={project.tool} />
  </Flex>
)

export default ProjectInfo
